import errorCustomHandle from '@/lib/error-custom-handle';
import { useApi } from '@/provider';
import type { CLUser } from '@local/domain';
import { CustomDialog, flatSx } from '@local/ui';
import CloseIcon from '@mui/icons-material/Close';
import type { SxProps, Theme } from '@mui/material';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import clsx from 'clsx';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

const rootSx: SxProps<Theme> = (theme) => ({});

export type PswdMustChangeDialogProps = {
  sx?: SxProps;
  className?: string;
  open: boolean;
  onClose: () => void;
  data: CLUser;
  // onSubmit
  clientVersion?: boolean;
};

export default function PswdMustChangeDialog(props: PswdMustChangeDialogProps) {
  const { sx, className, open, onClose, data, clientVersion } = props;
  const api = useApi();
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => {
    onClose();
  };

  const doUpdate = useCallback(
    async (params: { userId: number; lgonId: string }): Promise<CLUser | null> => {
      setLoading(true);
      try {
        const { body } = await api.userManage.updatePassword(params);
        const { user } = body;
        toast.success('비밀번호 변경 완료');

        return user;
      } catch (err) {
        // handleError(err)
        errorCustomHandle(err);
      } finally {
        setLoading(false);
      }
      return null;
    },
    [api],
  );

  const onPswdInitHandle = () => {
    console.log('버튼이 눌리긴하냐??');
    doUpdate({ userId: data.userId, lgonId: data.lgonId });
    handleCloseDialog();
  };

  return (
    <CustomDialog
      maxWidth="xs"
      fullWidth
      className={clsx('PswdMustChangeDialog-root', className)}
      sx={flatSx(rootSx, sx)}
      open={open}
      onClose={handleCloseDialog}
    >
      <Stack direction="row" justifyContent="center" mt={2.5} mx={1.5} alignItems="center">
        <Stack flex={1} />
        {clientVersion ? (
          <Typography
            sx={{
              em: {
                color: 'secondary.main',
                fontStyle: 'normal',
              },
            }}
            variant="h5"
          >
            <em>{data.lgonId}</em>의 비밀번호 변경
          </Typography>
        ) : (
          <Typography
            sx={{
              em: {
                color: 'secondary.main',
                fontStyle: 'normal',
              },
            }}
            variant="h5"
          >
            <em>{data.lgonId}</em>의 비밀번호 초기화
          </Typography>
        )}
        <Stack direction="row" justifyContent="flex-end" flex={1}>
          <IconButton onClick={handleCloseDialog}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </Stack>
      <DialogContent sx={{ overflow: 'hidden', px: 1, pt: 4, pb: 0 }}>
        <Box
          component="ul"
          sx={{
            mt: 5,
            em: {
              color: 'secondary.main',
              fontStyle: 'normal',
            },
          }}
        >
          <li>
            초기화될 비밀번호는 <em>사번1!</em> 입니다.
          </li>
          <li>사용자에게 초기비밀번호 값을 알려줘야 합니다.</li>
          {!clientVersion && (
            <li>
              사용자 최초 로그인시 반드시 비밀번호를 <em>변경</em>해야 합니다
            </li>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onPswdInitHandle} color="secondary">
          초기화
        </Button>
        <Button onClick={handleCloseDialog} color="secondary">
          취소
        </Button>
      </DialogActions>
    </CustomDialog>
  );
}
